export const PREMATCH_READ_MODEL_RECOVERY_BYPASS_QUERY_KEY = 'prematch_read_model_bypass';
export const PREMATCH_READ_MODEL_RECOVERY_BYPASS_QUERY_VALUE = 'bet_reject_recovery';
export const PREMATCH_READ_MODEL_RECOVERY_CACHE_BUST_QUERY_KEY = 'prematch_read_model_recovery_ts';

const normalizeBettingType = (value) => String(value || '').trim().toUpperCase();

const buildRecoveryCacheBustValue = (options = {}) => {
  const provided = options.cacheBust ?? options.now;
  if (provided !== undefined && provided !== null && provided !== '') return String(provided);

  const timestamp = typeof Date !== 'undefined' && typeof Date.now === 'function'
    ? Date.now()
    : 0;
  const suffix = typeof Math !== 'undefined' && typeof Math.random === 'function'
    ? Math.random().toString(36).slice(2, 8)
    : '0';
  return `${timestamp}-${suffix}`;
};

export const buildPrematchRecoveryRefreshParams = (params = {}, options = {}) => {
  const forceCurrentOddsPath = options.forceCurrentOddsPath === true;
  const bettingType = normalizeBettingType(options.bettingType ?? params?.betting_category);

  if (!forceCurrentOddsPath || bettingType === 'LIVE') return params;

  return {
    ...params,
    [PREMATCH_READ_MODEL_RECOVERY_BYPASS_QUERY_KEY]: PREMATCH_READ_MODEL_RECOVERY_BYPASS_QUERY_VALUE,
    [PREMATCH_READ_MODEL_RECOVERY_CACHE_BUST_QUERY_KEY]: buildRecoveryCacheBustValue(options),
  };
};
